import React, { useContext, useEffect, useState } from 'react';
import Link from 'next/link';
import { Formik, Form } from 'formik';
import { MySelect, MyTextInput } from 'Atoms/Formik';
import { useRouter } from 'next/router';
import API from 'Services/api';
import toast, { Toaster } from 'react-hot-toast';
import { PUCLoginSchema } from 'Lib/validators';
import { Modal } from 'react-bootstrap';
import Cookies from 'js-cookie';
import { UserContext } from 'Lib/contexts/OrderContext';
import { errorObj } from 'Lib/constants';
import { Notices } from 'Molecules/';

const Index = () => {
  const router = useRouter();
  const [parks, setParks] = useState([]);
  const [show, setShow] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const { isLogin, setIsLogin } = useContext(UserContext);

  var initialValues = {
    email: '',
    password: '',
    park: '',
  };
  useEffect(() => {
    setIsLogin(false);
    
    async function apiHit() {
      try {
        const { data } = await API.get("/parks/listManaged");
        if (data?.message === "Success") {
          setParks(data?.data?.parks);
        }
      } catch (error) {
        console.log(error);
      }
    }
    apiHit();
  }, []);

  const handleRegister = () => {
    localStorage.removeItem('puc_register_data');
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    try {
      const { data } = await API.post('/puc/forgot-password-email', {
        email: forgotEmail,
        host: process.env.NEXT_PUBLIC_WEB_URL,
      });
      if (data?.message === 'Success') {
        toast.success('Password reset email sent successfully');
        setForgotEmail('');
        handleClose();
      }
      console.log(data);
    } catch (error) {
      toast(error.response.data.error, errorObj);
    }
  };

  return (
    <>
      <div className='container'>
        <div>
          <Toaster />
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={PUCLoginSchema}
          onSubmit={async (values) => {
            try {
              const { data } = await API.post('/puc/login', {
                email: values.email,
                password: values.password,
                parkId: values.park,
              });
              // console.log(data?.data);
              if (data?.message === 'Successfully logged in.') {
                localStorage.removeItem('puc_login_data');

                setIsLogin(true);

                localStorage.setItem(
                  'puc_login_data',
                  JSON.stringify(data?.data)
                );
                
                
                const parkData = await API.get("/parks/data", {
                  params: { parkId: values.park },
                });
                
                /*console.log('PARK >>>>> ' + parkData.data.data)*/
                
                if (parkData.data.message === "Success") {
                  
                  
                  localStorage.setItem('parkData', JSON.stringify(parkData.data.data));
                }
                
                

                Cookies.set('token', data?.data?.jwtToken, { expires: 1 });
                Cookies.set('userId', data?.data?.userId, { expires: 1 });
                Cookies.set('login', true);
                Cookies.set('parkId', values.park)
                toast.success('Login Successful');
                router.push('/reservations');
              }
            } catch (error) {
              toast(error.response.data.error, errorObj);
            }
          }}
        >
          {(props) => {
            return (
              <Form>
                <div className='row row-padding-top'>
                  <div className='col-xl-6 col-md-6'>
                    <h1 className="h2"><strong>PUC Login:</strong></h1>

                    <div className='row' style={{ paddingTop: '15px' }}>
                      <div className='col-xl-3 col-3'>
                        <label htmlFor='email'>Email</label>
                      </div>
                      <div className='col-xl-9 col-9'>
                        <MyTextInput
                          id="email"
                          name='email'
                          type='email'
                          className='form-control'
                        />
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-xl-3 col-3'>
                        <label htmlFor='people'>Password</label>
                      </div>
                      <div className='col-xl-9 col-9'>
                        <MyTextInput
                          name='password'
                          type='password'
                          className='form-control'
                        />
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-xl-3 col-3'>
                        <label htmlFor='park'>Select park</label>
                      </div>
                      <div className='col-xl-9 col-9'>
                        <MySelect
                          id="park"
                          name='park'
                          className='form-control'
                          placeholder='Choose one...'
                        >
                          <option value="">-- Select Park --</option>
                          {parks?.map((park) => (
                            <option value={park._id} key={park._id}>{park.parkName}</option>
                          ))}
                          {/*<option value='AL'>
                            Diamond Head State Monument
                          </option>*/}
                        </MySelect>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: '40px' }}>
                  <button type='submit' className='btn btn-primary'>
                    Login
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
        <div className='row'>
          <div className='col-md-6 col-sm-6 col-xs-12'>
            <p>
              Don't have an account?{' '}
              <Link href='/registration'>
                <a onClick={handleRegister}>Register now</a>
              </Link>
              .<br />
              Forgot your{' '}
              <span className='forgotpassword-container' onClick={handleShow}>
                password
              </span>
              ?
            </p>

            <Modal show={show} onHide={handleClose}>
              <form onSubmit={handleForgotPassword}>
                <Modal.Header>
                  <h2>Enter your email</h2>
                </Modal.Header>
                <Modal.Body>
                  <div className='row'>
                    <div className='col-12'>
                      <p>We'll send you an email with a password reset link.</p>
                      <label htmlFor='forgotEmail'>Email</label>
                      <input
                        id="forgotEmail"
                        type='email'
                        className='form-control'
                        value={forgotEmail}
                        onChange={(e) => setForgotEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    className='btn btn-primary'
                    data-bs-dismiss='modal'
                    type='submit'
                  >
                    Send email
                  </button>
                </Modal.Footer>
              </form>
            </Modal>

            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
